import { LoadableLazy } from '@confluence/loadable';

export const CopySpacePermissionsAndDefaultPermissionsLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CopySpacePermissionsAndDefaultPermissions" */ './CopySpacePermissionsAndDefaultPermissions.tsx'
			)
		).CopySpacePermissionsAndDefaultPermissions,
});
